<template>
  <div id="app">
    <headers></headers>
    <router-view />
    <footers></footers>
  </div>
</template>

<script>
import headers from '@/components/header.vue';
import footers from '@/components/footer.vue';
  export default {
    components:{headers,footers},
    name: "App",
  };
</script>

<style>
  body {
    margin: 0;
  }
  #app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    /* text-align: center; */
  }
</style>



// WEBPACK FOOTER //
// src/App.vue